import {
  Col,
  Row,
  Tabs,
  Modal,
  Upload,
  Button as AntButton,
  Popconfirm,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
// import * as Icon from "react-icons/all";
import moment from "moment";
import React, { useEffect, useState } from "react";

import { Colors, Fonts } from "../../config";
import {
  Pagination,
  Switch,
  Table,
  Text,
  TextField,
  Button,
} from "../../components";

import {
  MontserratBold,
  MontserratLight,
  MontserratRegular,
} from "../../config/fonts";
import { UserAction } from "../../store/actions";
import { FaSearch } from "react-icons/fa";
import { MdEmail, MdDelete } from "react-icons/md";
import { UploadOutlined } from "@ant-design/icons";

function UserManagement() {
  const dispatch = useDispatch();
  const users = useSelector((state) => state.user);
  const [page, setPage] = useState(1);
  const [location, setLocation] = useState("");
  const [activeTab, setActiveTab] = useState("1");
  const [state, setState] = useState({
    limit: 10,
    offset: 0,
    keyword: "",
    status: "",
    location_Id: "",
    location_type: "",
    is_admin_assign: null,
  });

  // Email modal states
  const [emailModalVisible, setEmailModalVisible] = useState(false);
  const [bulkEmailModalVisible, setBulkEmailModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [emailForm, setEmailForm] = useState({
    message: "",
    attachments: [],
  });

  // Create user modal states
  const [createUserModalVisible, setCreateUserModalVisible] = useState(false);
  const [createUserForm, setCreateUserForm] = useState({
    full_name: "",
    email: "",
    allow_in_app_purchase: false,
  });

  const handlePagination = (pageNumber) => {
    let offset = (pageNumber - 1) * state.limit;
    setState({ ...state, offset: offset });
    setPage(pageNumber);
  };

  const handleChangeStatus = (id) => {
    dispatch(
      UserAction.changeUserStatus(id, () => {
        dispatch(UserAction.getUserListing(state));
        setPage(1);
      }),
    );
  };

  const handleSearchLocation = (e, value) => {
    setLocation(e);
    dispatch(UserAction.getUserLocations(e));
  };

  const handleClearLocation = () => {
    setState({
      ...state,
      location_Id: "",
      location_type: "",
    });
  };

  const handleSelectLocation = (e) => {
    const location = e.split("_");
    setLocation(location[0]);
    setPage(1);
    setState({
      ...state,
      offset: 0,
      location_Id: location[2],
      location_type: location[1],
    });
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    setPage(1);
    setState({
      ...state,
      offset: 0,
      is_admin_assign: key === "1" ? null : true,
    });
  };

  const handleOpenEmailModal = (user) => {
    setSelectedUser(user);
    setEmailModalVisible(true);
  };

  const handleCloseEmailModal = () => {
    setEmailModalVisible(false);
    setSelectedUser(null);
    setEmailForm({ message: "", attachments: [] });
  };

  const handleOpenBulkEmailModal = () => {
    setBulkEmailModalVisible(true);
  };

  const handleCloseBulkEmailModal = () => {
    setBulkEmailModalVisible(false);
    setEmailForm({ message: "", attachments: [] });
  };

  const handleSendEmail = () => {
    if (!emailForm.message) {
      return;
    }
    const payload = {
      user_id: selectedUser.id,
      message: emailForm.message,
      attachments: emailForm.attachments,
    };
    dispatch(
      UserAction.sendUserEmail(payload, () => {
        handleCloseEmailModal();
      }),
    );
  };

  const handleSendBulkEmail = () => {
    if (!emailForm.message) {
      return;
    }
    const payload = {
      is_admin_assign: state.is_admin_assign,
      message: emailForm.message,
      attachments: emailForm.attachments,
    };
    dispatch(
      UserAction.sendBulkEmail(payload, () => {
        handleCloseBulkEmailModal();
      }),
    );
  };

  const handleDeleteUser = (id) => {
    dispatch(
      UserAction.deleteUser(id, () => {
        dispatch(UserAction.getUserListing(state));
        setPage(1);
      }),
    );
  };

  const handleFileChange = (info) => {
    const validFiles = info.fileList
      .filter((f) => f.originFileObj)
      .map((f) => f.originFileObj);
    setEmailForm({ ...emailForm, attachments: validFiles });
  };

  // Create user handlers
  const handleOpenCreateUserModal = () => {
    setCreateUserModalVisible(true);
  };

  const handleCloseCreateUserModal = () => {
    setCreateUserModalVisible(false);
    setCreateUserForm({
      full_name: "",
      email: "",
      allow_in_app_purchase: false,
    });
  };

  const handleCreateUser = () => {
    if (!createUserForm.full_name || !createUserForm.email) {
      return;
    }
    const payload = {
      full_name: createUserForm.full_name,
      email: createUserForm.email,
      allow_in_app_purchase: createUserForm.allow_in_app_purchase,
    };
    dispatch(
      UserAction.createUser(payload, () => {
        handleCloseCreateUserModal();
        dispatch(UserAction.getUserListing(state));
      }),
    );
  };

  useEffect(() => {
    dispatch(UserAction.getUserListing(state));
  }, [page, state]);

  return (
    <div className="wrapper">
      <Row className="flex-row-space-center mb-5 mx-15">
        <Col className="flex-column" span={15}>
          <div className="flex-row-align-center">
            <Text.Basic
              text="Users Management"
              color={Colors.Black}
              fontSize={25}
              fontWeight={600}
              fontFamily={Fonts[MontserratBold]}
              textAlign="left"
            />
            <span
              style={{
                width: "8px",
                height: "8px",
                background: "#7836FF",
                borderRadius: "50px",
                marginInline: "10px",
              }}
            ></span>
            <Text.Basic
              text={users?.count}
              color={Colors.Black}
              fontSize={18}
              fontWeight={400}
              fontFamily={Fonts[MontserratRegular]}
              textAlign="left"
            />
          </div>
          <Text.Basic
            text={`Deleted users: ${users?.deleted}`}
            color={Colors.LightGray}
            fontSize={16}
            fontWeight={300}
            fontFamily={Fonts[MontserratLight]}
            textAlign="left"
          />
          <Text.Basic
            text={`These are the users currently registered in the app`}
            color={Colors.LightGray}
            fontSize={14}
            fontWeight={300}
            fontFamily={Fonts[MontserratLight]}
            textAlign="left"
            className=""
          />
        </Col>
        {/* <Col span={9} style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button.Basic
            text="Send Email to All"
            onClick={handleOpenBulkEmailModal}
            type="primary"
            buttonStyle={{ height: "40px" }}
          />
        </Col> */}
      </Row>
      <Row className="mx-15 mb-3">
        <Col span={24}>
          <Row className="gap-2">
            <Col>
              <TextField.IconField
                className="listing-filter"
                size={"large"}
                suffix={<FaSearch />}
                placeholder={"Search Users"}
                value={state.keyword}
                onChange={(e) =>
                  setState({
                    ...state,
                    keyword: e.target.value,
                  })
                }
              />
            </Col>
            <Col className="user-location-search">
              <TextField.Autocomplete
                inputStyle={{ width: "200px" }}
                suffixIcon={<FaSearch size={16} color="black" />}
                size={"large"}
                onClear={handleClearLocation}
                notFoundContent={"No location found"}
                value={location ? location : undefined}
                placeholder={"Search by location"}
                onSearch={handleSearchLocation}
                onSelect={handleSelectLocation}
                options={users?.locations}
                allowClear={false}
              />
            </Col>
            <Col>
              <TextField.SelectField
                inputStyle={{ width: "100%" }}
                className="listing-filter"
                size={"large"}
                allowClear={false}
                onChange={(value) => {
                  if (value === "all") {
                    setState({
                      ...state,
                      status: "",
                    });
                  } else {
                    setState({
                      ...state,
                      status: value,
                    });
                  }
                }}
                value={state.status === "" ? "all" : state.status}
                options={[
                  {
                    label: "View All",
                    value: "all",
                  },
                  {
                    label: "Active",
                    value: "active",
                  },
                  {
                    label: "In-active",
                    value: "inactive",
                  },
                ]}
              />
            </Col>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <Button.Basic
                text="Add New User"
                onClick={handleOpenCreateUserModal}
                type="primary"
                buttonStyle={{ height: "40px", backgroundColor: "#28a745" }}
              />
              <Button.Basic
                text="Send Email to All"
                onClick={handleOpenBulkEmailModal}
                type="primary"
                buttonStyle={{ height: "40px" }}
              />
            </Col>
          </Row>
        </Col>
      </Row>

      <Tabs activeKey={activeTab} onChange={handleTabChange}>
        <Tabs.TabPane tab="Commercial Users" key="1">
          <Table.Basic
            columns={[
              {
                title: "Full Name",
                dataIndex: "name",
                key: "name",
                render: (text, record) => (
                  <span className="ml-10 table-cell" title={text}>
                    {text.length > 15 ? `${text.slice(0, 15)}...` : text}
                  </span>
                ),
              },
              {
                title: "Email",
                dataIndex: "email",
                key: "email",
                render: (text, record) => (
                  <span className="table-cell" title={text}>
                    {text.length > 25 ? `${text.slice(0, 25)}...` : text}
                  </span>
                ),
              },
              {
                title: "Location",
                dataIndex: "city",
                key: "city",
                render: (text, record) => (
                  <span className="table-cell" title={text}>
                    {text !== null
                      ? // text?.length > 15
                        //   ? `${text.slice(0, 15)}...`
                        //   :
                        text
                      : "-"}
                  </span>
                ),
              },
              {
                title: "Subscription",
                dataIndex: "subscription",
                key: "subscription",
                render: (text, record) => (
                  <span
                    className="table-cell"
                    style={{
                      color:
                        text === "Subscribed"
                          ? Colors.BlueText
                          : text === "Free"
                            ? Colors.Black
                            : Colors.DarkGray,
                      textTransform: "capitalize",
                    }}
                  >
                    {text}
                  </span>
                ),
              },
              {
                title: "Expiry Date",
                dataIndex: "expiry_date",
                key: "expiry_date",
                render: (text, record) => (
                  <span className="table-cell">
                    {text === "The user has not activated their trial yet."
                      ? "-"
                      : moment(text).format("DD MMM, YYYY")}
                  </span>
                ),
              },
              // {
              //   title: "Status",
              //   dataIndex: "status",
              //   key: "status",
              //   render: (text, record) => (
              //     <span
              //       className="table-cell"
              //       style={{
              //         color: text === "active" ? Colors.BlueText : Colors.RedText,
              //         backgroundColor:
              //           text === "active" ? "#7836FF1A" : "#FF606B1A",
              //         padding: "10px",
              //         borderRadius: "10px",
              //         textTransform: "capitalize",
              //       }}
              //     >
              //       {text}
              //     </span>
              //   ),
              // },
              {
                title: "Email",
                dataIndex: "",
                key: "actions",
                render: (text, record) => (
                  <span
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <MdEmail
                      size={26}
                      color="#7836FF"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleOpenEmailModal(record)}
                      title="Send Email"
                    />
                  </span>
                ),
              },
              {
                title: "Delete",
                dataIndex: "",
                key: "actions",
                render: (text, record) => (
                  <span
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <Popconfirm
                      title="Are you sure you want to delete this user?"
                      onConfirm={() => handleDeleteUser(record.id)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <MdDelete
                        size={26}
                        color="#FF606B"
                        style={{ cursor: "pointer" }}
                        title="Delete User"
                      />
                    </Popconfirm>
                  </span>
                ),
              },
              {
                title: "Status",
                dataIndex: "",
                key: "",
                render: (text, record) => (
                  <span>
                    <Switch.Basic
                      checked={record.status !== "suspended" ? true : false}
                      onChange={(e) => handleChangeStatus(record?.id)}
                    />
                  </span>
                ),
              },
            ]}
            data={users?.users}
            loading={users.isLoading}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Admin Assigned Users" key="2">
          <Table.Basic
            columns={[
              {
                title: "Full Name",
                dataIndex: "name",
                key: "name",
                render: (text, record) => (
                  <span className="ml-10 table-cell" title={text}>
                    {text.length > 15 ? `${text.slice(0, 15)}...` : text}
                  </span>
                ),
              },
              {
                title: "Email",
                dataIndex: "email",
                key: "email",
                render: (text, record) => (
                  <span className="table-cell" title={text}>
                    {text.length > 25 ? `${text.slice(0, 25)}...` : text}
                  </span>
                ),
              },
              {
                title: "Location",
                dataIndex: "city",
                key: "city",
                render: (text, record) => (
                  <span className="table-cell" title={text}>
                    {text !== null
                      ? text?.length > 15
                        ? `${text.slice(0, 15)}...`
                        : text
                      : "-"}
                  </span>
                ),
              },
              {
                title: "Subscription",
                dataIndex: "subscription",
                key: "subscription",
                render: (text, record) => (
                  <span
                    className="table-cell"
                    style={{
                      color:
                        text === "Subscribed"
                          ? Colors.BlueText
                          : text === "Free"
                            ? Colors.Black
                            : Colors.DarkGray,
                      textTransform: "capitalize",
                    }}
                  >
                    {text}
                  </span>
                ),
              },
              {
                title: "Expiry Date",
                dataIndex: "expiry_date",
                key: "expiry_date",
                render: (text, record) => (
                  <span className="table-cell">
                    {text === "The user has not activated their trial yet."
                      ? "-"
                      : moment(text).format("DD MMM, YYYY")}
                  </span>
                ),
              },
              {
                title: "In-App Purchase",
                dataIndex: "allow_in_app_purchase",
                key: "allow_in_app_purchase",
                render: (text, record) => (
                  <span
                    className="table-cell"
                    style={{ textAlign: "center", display: "block" }}
                  >
                    {text === 1 ? "Yes" : "No"}
                  </span>
                ),
              },
              {
                title: "Status",
                dataIndex: "status",
                key: "status",
                render: (text, record) => (
                  <span
                    className="table-cell"
                    style={{
                      color:
                        text === "active" ? Colors.BlueText : Colors.RedText,
                      backgroundColor:
                        text === "active" ? "#7836FF1A" : "#FF606B1A",
                      padding: "10px",
                      borderRadius: "10px",
                      textTransform: "capitalize",
                    }}
                  >
                    {text}
                  </span>
                ),
              },
              {
                title: "Actions",
                dataIndex: "",
                key: "actions",
                render: (text, record) => (
                  <span
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <MdEmail
                      size={22}
                      color="#7836FF"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleOpenEmailModal(record)}
                      title="Send Email"
                    />
                    <Popconfirm
                      title="Are you sure you want to delete this user?"
                      onConfirm={() => handleDeleteUser(record.id)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <MdDelete
                        size={22}
                        color="#FF606B"
                        style={{ cursor: "pointer" }}
                        title="Delete User"
                      />
                    </Popconfirm>
                  </span>
                ),
              },
            ]}
            data={users?.users}
            loading={users.isLoading}
          />
        </Tabs.TabPane>
      </Tabs>

      {users.count > 10 && (
        <Row justify={"center"} className="mt-10">
          <Col>
            <Pagination.Basic
              onChange={handlePagination}
              pageSize={10}
              current={page}
              total={users.count}
            />
          </Col>
        </Row>
      )}

      {/* Single Email Modal */}
      <Modal
        title="Send Email to User"
        open={emailModalVisible}
        onCancel={handleCloseEmailModal}
        footer={[
          <AntButton key="cancel" onClick={handleCloseEmailModal}>
            Cancel
          </AntButton>,
          <AntButton
            key="send"
            type="primary"
            onClick={handleSendEmail}
            disabled={!emailForm.message}
          >
            Send
          </AntButton>,
        ]}
      >
        <div style={{ marginBottom: "16px" }}>
          <label style={{ fontWeight: "bold" }}>Name</label>
          <TextField.IconField
            value={selectedUser?.name || ""}
            disabled
            style={{ marginTop: "8px" }}
          />
        </div>
        <div style={{ marginBottom: "16px" }}>
          <label style={{ fontWeight: "bold" }}>Email</label>
          <TextField.IconField
            value={selectedUser?.email || ""}
            disabled
            style={{ marginTop: "8px" }}
          />
        </div>
        <div style={{ marginBottom: "16px" }}>
          <label style={{ fontWeight: "bold" }}>Message</label>
          <TextField.Textarea
            rows={4}
            value={emailForm.message}
            onChange={(e) =>
              setEmailForm({ ...emailForm, message: e.target.value })
            }
            placeholder="Type your message here..."
            style={{ marginTop: "8px" }}
          />
        </div>
        <div className="gap-4">
          <label style={{ fontWeight: "bold" }}>Attachments</label>
          <div>
            <Upload
              multiple
              beforeUpload={() => false}
              onChange={handleFileChange}
              fileList={emailForm.attachments.map((file, idx) => ({
                uid: idx,
                name: file.name,
                status: "done",
                originFileObj: file,
              }))}
            >
              <AntButton icon={<UploadOutlined />} style={{ marginTop: "8px" }}>
                Select Files
              </AntButton>
            </Upload>
          </div>
        </div>
      </Modal>

      {/* Bulk Email Modal */}
      <Modal
        title="Send Email to All Users"
        open={bulkEmailModalVisible}
        onCancel={handleCloseBulkEmailModal}
        footer={[
          <AntButton key="cancel" onClick={handleCloseBulkEmailModal}>
            Cancel
          </AntButton>,
          <AntButton
            key="send"
            type="primary"
            onClick={handleSendBulkEmail}
            disabled={!emailForm.message}
          >
            Send
          </AntButton>,
        ]}
      >
        <div style={{ marginBottom: "16px" }}>
          <label style={{ fontWeight: "bold" }}>Message</label>
          <TextField.Textarea
            rows={4}
            value={emailForm.message}
            onChange={(e) =>
              setEmailForm({ ...emailForm, message: e.target.value })
            }
            placeholder="Type your message here..."
            style={{ marginTop: "8px" }}
          />
        </div>
        <div>
          <label style={{ fontWeight: "bold" }}>Attachments</label>
          <div>
            <Upload
              multiple
              beforeUpload={() => false}
              onChange={handleFileChange}
              fileList={emailForm.attachments.map((file, idx) => ({
                uid: idx,
                name: file.name,
                status: "done",
                originFileObj: file,
              }))}
            >
              <AntButton icon={<UploadOutlined />} style={{ marginTop: "8px" }}>
                Select Files
              </AntButton>
            </Upload>
          </div>
        </div>
      </Modal>

      {/* Create User Modal */}
      <Modal
        title="Add New User"
        open={createUserModalVisible}
        onCancel={handleCloseCreateUserModal}
        footer={[
          <AntButton key="cancel" onClick={handleCloseCreateUserModal}>
            Cancel
          </AntButton>,
          <AntButton
            key="create"
            type="primary"
            onClick={handleCreateUser}
            disabled={!createUserForm.full_name || !createUserForm.email}
            loading={users.createUserLoader}
          >
            Create
          </AntButton>,
        ]}
      >
        <div style={{ marginBottom: "16px" }}>
          <label style={{ fontWeight: "bold" }}>Full Name *</label>
          <TextField.IconField
            value={createUserForm.full_name}
            onChange={(e) =>
              setCreateUserForm({
                ...createUserForm,
                full_name: e.target.value,
              })
            }
            placeholder="Enter full name"
            style={{ marginTop: "8px" }}
          />
        </div>
        <div style={{ marginBottom: "16px" }}>
          <label style={{ fontWeight: "bold" }}>Email *</label>
          <TextField.IconField
            value={createUserForm.email}
            onChange={(e) =>
              setCreateUserForm({ ...createUserForm, email: e.target.value })
            }
            placeholder="Enter email address"
            type="email"
            style={{ marginTop: "8px" }}
          />
        </div>
        <div
          style={{
            marginBottom: "16px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <label style={{ fontWeight: "bold" }}>Allow in app purchases</label>
            <Switch.Basic
              checked={createUserForm.allow_in_app_purchase}
              onChange={(checked) =>
                setCreateUserForm({
                  ...createUserForm,
                  allow_in_app_purchase: checked,
                })
              }
            />
          </div>
          <p style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
            By enabling this the user will bypass all the in-app purchases that
            includes create ad , book interview , register event and download
            video/audio song
          </p>
        </div>
      </Modal>
    </div>
  );
}

export default UserManagement;
